<template>
  <div
    class="goal-content body-content page-card-wrapper"
    :class="this.$store.state.locale.currentLocale === 'de' ? 'de-wrapper' : ''"
  >
    <div class="page-card-title">
      <span class="page-card-title-text">{{ $t('text.desire_position') }}</span>
    </div>
    <div class="page-card-content">
      <div class="mt-30 page-content">
        <div class="light-blue-font mb-30">
          {{ $t('text.day_goal').toUpperCase() }}
        </div>
        <div class="slider-wrapper h-100">
          <span
            v-if="dayValue"
            class="value-text light-blue-font"
            :style="{ left: dayValue / (this.max / 100) + '%' }"
            >{{ dayValueText }}</span
          >
          <el-slider
            v-model="dayValue"
            :min="0"
            :max="max"
            :step="0.5"
            :show-tooltip="false"
            @change="handleDaySliderChange()"
          >
          </el-slider>
          <div class="min-value light-blue-font">{{ $t('text.off') }}</div>
          <div class="max-value light-blue-font">{{ max }}h</div>
        </div>
        <div class="light-blue-font mt-20">
          {{ $t('text.night_goal').toUpperCase() }}
        </div>
        <div class="slider-wrapper h-100 mt-30">
          <span
            v-if="nightValue"
            class="value-text light-blue-font"
            :style="{ left: nightValue / (this.max / 100) + '%' }"
            >{{ nightValueText }}</span
          >
          <el-slider
            v-model="nightValue"
            :min="0"
            :max="max"
            :step="0.5"
            :show-tooltip="false"
            @change="handleNightSliderChange()"
          >
          </el-slider>
          <div class="min-value light-blue-font">{{ $t('text.off') }}</div>
          <div class="max-value light-blue-font">{{ max }}h</div>
        </div>
        <div class="partial-body-reposition-box">
          <div class="text-right">
            <el-switch
              v-model="partialBodyRepositonActive"
              active-color="#D4F78E"
            >
            </el-switch>
            <span class="light-blue-font ml-5">{{
              $t('text.partial_body_repositioning')
            }}</span>
          </div>
          <div v-if="partialBodyRepositonActive">
            <div class="light-blue-font mb-30">
              {{ $t('text.minimum_angle_change').toUpperCase() }}
            </div>
            <div class="slider-wrapper h-100 mt-30">
              <span
                v-if="degreeValue !== degreeMin"
                class="value-text light-blue-font"
                :style="{
                  left:
                    (degreeValue - degreeMin) /
                      ((degreeMax - degreeMin) / 100) +
                    '%'
                }"
                >{{ degreeValue }} {{ $t('text.degrees') }}</span
              >
              <el-slider
                v-model="degreeValue"
                :min="degreeMin"
                :max="degreeMax"
                :step="1"
                :show-tooltip="false"
              >
              </el-slider>
              <div class="min-value light-blue-font">
                {{ degreeMin }} {{ $t('text.degrees') }}
              </div>
              <div class="max-value light-blue-font">
                {{ degreeMax }} {{ $t('text.degrees') }}
              </div>
            </div>
          </div>
        </div>
        <div class="text-right mt-10">
          <b-button variant="outline-primary" class="mr-25 visibile-hide">{{
            $t('text.default').toUpperCase()
          }}</b-button>
          <el-button
            type="success"
            plain
            class="common-btn"
            :loading="saveLoading"
            @click="save()"
            :disabled="saveLoading"
            v-if="p('Patients.Goals Module.Position.Save')"
            >{{ $t('text.save').toUpperCase() }}</el-button
          >
        </div>
        <div class="mt-30" v-if="notAllowOff">
          <img class="mr-10" src="@/assets/image/yellow-warn.svg" />
          <span class="dark-grey-font alert-text">{{
            $t('text.position_goal_not_allow_off')
          }}</span>
        </div>
        <div class="setting-wrapper mt-40 mb-30">
          <div class="image-wrapper inline-block">
            <img src="@/assets/image/light.svg" />
          </div>
          <div class="inline-block">
            <div class="first-row">
              <span class="left-side">
                <span class="inline-block label"
                  >{{ $t('text.average_time_in_position') }}:</span
                >
                <span class="inline-block w-105">
                  <span v-if="patientData.AgvTimeinPos">
                    <span v-if="secondFormat(patientData.AgvTimeinPos)[0]"
                      >{{ secondFormat(patientData.AgvTimeinPos)[0] }}d
                    </span>
                    <span v-if="secondFormat(patientData.AgvTimeinPos)[1]">
                      {{ secondFormat(patientData.AgvTimeinPos)[1] }}h
                    </span>
                    <span v-if="secondFormat(patientData.AgvTimeinPos)[2]"
                      >{{ secondFormat(patientData.AgvTimeinPos)[2] }}min</span
                    >
                  </span>
                  <span v-else>0min</span>
                  {{ $t('text.per_day') }}</span
                >
              </span>
              <span class="right-side">
                <span class="label inline-block"
                  >{{ $t('text.repositioning_24h') }}:</span
                >
                <span
                  >{{ patientData.Reposition }} {{ $t('text.per_day') }} ({{
                    $t('text.avg')
                  }})</span
                >
              </span>
            </div>
            <div class="second-row">
              <span class="left-side">
                <span class="inline-block label"
                  >{{ $t('text.max_time_in_a_pos') }}:</span
                >
                <span class="inline-block w-105">
                  <span v-if="patientData.MaxTimeInPos">
                    <span v-if="secondFormat(patientData.MaxTimeInPos)[0]"
                      >{{ secondFormat(patientData.MaxTimeInPos)[0] }}d
                    </span>
                    <span v-if="secondFormat(patientData.MaxTimeInPos)[1]">
                      {{ secondFormat(patientData.MaxTimeInPos)[1] }}h
                    </span>
                    <span v-if="secondFormat(patientData.MaxTimeInPos)[2]"
                      >{{ secondFormat(patientData.MaxTimeInPos)[2] }}min</span
                    >
                  </span>
                  <span v-else>0min</span>
                </span>
              </span>
              <span class="right-side"
                >{{ $t('text.last_7_day_period') }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ApiService from '@/services/ApiService.js'
import swal from 'sweetalert'
export default {
  data() {
    return {
      dayValue: 0,
      nightValue: 0,
      max: 16,
      lastDayValue: '',
      lastNightValue: '',
      notAllowOff: false,
      goal: {},
      patientData: {},
      saveLoading: false,
      // partial body repositon params
      partialBodyRepositonActive: false,
      degreeMin: 15,
      degreeMax: 60,
      degreeValue: 0
    }
  },
  watch: {
    dayValue: {
      handler: function(newVal, oldVal) {
        this.lastDayValue = oldVal
      },
      deep: true
    },
    nightValue: {
      handler: function(newVal, oldVal) {
        this.lastNightValue = oldVal
      },
      deep: true
    },
    '$store.state.patient.selectedPatientGoal': function() {
      this.getInitVal()
    },
    '$store.state.patient.selectedPatientData': function() {
      this.getPatientData()
    },
    partialBodyRepositonActive() {
      this.degreeValue = this.partialBodyRepositonActive ? 15 : 0
    }
  },
  computed: {
    secondFormat() {
      return function(num) {
        if (!num) return [0, 0, 0]
        let day = Math.floor(num / 86400)
        let hour = Math.floor((num - day * 86400) / 3600)
        let mimute = Math.floor((num - day * 86400 - hour * 3600) / 60)
        return [day, hour, mimute]
      }
    },
    dayValueText: function() {
      let num1 = Math.floor(this.dayValue)
      let num2 = (this.dayValue - num1) * 60
      if (num2) {
        if (num1) {
          return num1 + 'h' + ' ' + num2 + 'm'
        } else {
          return num2 + 'min'
        }
      }
      return num1 + 'h'
    },
    nightValueText: function() {
      let num1 = Math.floor(this.nightValue)
      let num2 = (this.nightValue - num1) * 60
      if (num2) {
        if (num1) {
          return num1 + 'h' + ' ' + num2 + 'm'
        } else {
          return num2 + 'min'
        }
      }
      return num1 + 'h'
    }
  },
  mounted() {
    this.$store.dispatch('patient/getSelectedPatientGoal')
    this.$store.dispatch('patient/getSelectedPatientHistoryData')
    this.getInitVal()
    this.getPatientData()
  },
  methods: {
    getInitVal() {
      this.goal = this.$store.state.patient.selectedPatientGoal
      this.dayValue = this.goal.MaxTimeInPosD / 3600
      this.nightValue = this.goal.MaxTimeInPosN / 3600
      this.notAllowOff = this.goal.IsFallGoalEnabled
      this.partialBodyRepositonActive = this.goal.IsPartialPositionEnabled
      this.degreeValue = this.goal.PartialPositionAngle
    },
    getPatientData() {
      this.patientData = this.$store.state.patient.selectedPatientData
    },
    handleDaySliderChange() {
      if (this.notAllowOff && this.dayValue === 0) {
        this.dayValue = this.lastDayValue
      }
    },
    handleNightSliderChange() {
      if (this.notAllowOff && this.nightValue === 0) {
        this.nightValue = this.lastNightValue
      }
    },
    save() {
      if (!this.$store.state.patient.selectedPatient) return false
      let params = {
        patientId: this.$store.state.patient.selectedPatient.patientId,
        MaxTimeInPosD: this.dayValue * 3600,
        MaxTimeInPosN: this.nightValue * 3600,
        IsPartialPositionEnabled: this.partialBodyRepositonActive,
        PartialPositionAngle: this.degreeValue
      }
      this.saveLoading = true
      ApiService.SavePositionGoal(params)
        .then(response => {
          this.saveLoading = false
          if (response.data.success) {
            this.$store.dispatch('patient/getSelectedPatientGoal')
            this.$store.dispatch('patient/getSelectedPatientHistoryData')
            swal({
              icon: 'success',
              timer: 2000,
              title: this.$t('text.saved_successfully')
            })
          } else {
            swal({
              icon: 'error',
              timer: 2000,
              title: this.$t('text.saved_failed'),
              text: response.data.msg
            })
          }
        })
        .catch(() => {
          this.saveLoading = false
          swal({
            icon: 'error',
            timer: 2000,
            title: this.$t('text.saved_failed')
          })
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.de-wrapper {
  .left-side {
    margin-right: 20px !important;
    .label {
      width: 220px;
    }
  }
  .right-side {
    .label {
      width: 130px;
    }
  }
}
</style>
